// Module
var code = "<modal title=\"{{$ctrl.title || ('Confirm' | translate)}}\" cancel=$ctrl.no() cancel-text=\"{{'No' | translate}}\" save=$ctrl.yes() save-text=\"{{'Yes' | translate}}\"> {{$ctrl.message}} </modal> ";
// Exports
module.exports = code;